import React, { useEffect } from "react";
import { Card, Respects, Footer } from "./styles"; // Importe o Footer
import Reports from "../../views/Reports";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import Slide from "../../components/Slide";
/* import RegisterOther from '../../components/RegisterOtherUser'; */
import { useLocation } from "react-router-dom";
import cookie from "../../services/cookie/index";
export default function Home() {
  /*   const [showRegisterModal, setShowRegisterModal] = useState(false); */
  const location = useLocation();

  const rawName = cookie().get("name"); // Ex: "PEDRO ALVAREZ CABRAL"
  // funcao que formata o name que esta em UPPERCASE
  const formatName = (name) => {
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  const name = rawName ? formatName(rawName) : "";
  useEffect(() => {
    if (location.state?.successMessage) {
      alert(location.state.successMessage);
    }
  }, [location.state]);

  /*   const handleOpenRegisterModal = () => {
    setShowRegisterModal(true);
  };

  const handleCloseRegisterModal = () => {
    setShowRegisterModal(false);
  }; */

  return (
    <div>
      <Slide
        title={
          <>
            <FontAwesomeIcon icon={faHome} /> Home
          </>
        }
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "20px",
          flexWrap:
            "wrap" /* Permite que os itens 'quebrem' para uma nova linha se necessário */,
          gap: "15px" /* Espaçamento entre os elementos */,
        }}
      >
        <Respects>
          Olá, <b>{name}</b>!
        </Respects>
        {/* <ButtonOther onClick={handleOpenRegisterModal}>
    Sou representante legal do paciente
    <FontAwesomeIcon icon={faUsers} style={{ marginLeft: '10px' }} />
  </ButtonOther> */}
      </div>
      {/*    {showRegisterModal && <RegisterOther onClose={handleCloseRegisterModal} />}
       */}
      <Card>
        <Reports />
      </Card>

      {/* Rodapé */}
      <Footer>
        Precisa de ajuda? Você pode entrar em contato pelo telefone ou WhatsApp
        através do número <strong>+55 (47) 99115-3595</strong>.
      </Footer>
    </div>
  );
}
